<span *ngIf="hint" class="my-hint" [matTooltip]="hint">
  <i class="flaticon-questions-circular-button"></i>
</span>